import React, { forwardRef, useEffect, useRef, useState } from 'react'
import PathSearch from '../common/sidebars/right/PathSearch'
import { Portal } from 'components/utility/portal'
import clsx from 'clsx'

const ConfirmRemoveSection = ({ onCancel, onSubmit }) => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap24">
      <div className="dome-d-flex dome-flex-column dome-align-start dome-gap12">
        <i style={{ fontSize: 50 }} className="fa-thin fa-circle-exclamation dome-color-med-grey"></i>
        <span className="dome-h2 dome-color-dark-grey">are you sure?</span>
      </div>
      <span className="dome-p1 dome-color-darkest-grey">Removing will unassign all paths.</span>
      <div className="dome-d-flex dome-justify-between">
        <button
          type="button"
          onClick={onCancel}
          className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
        >
          go back
        </button>
        <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-red-stroke">
          remove
        </button>
      </div>
    </div>
  )
}

const ConfirmRemoveSectionModal = forwardRef(
  ({ open = false, onClose = () => {}, onSubmit = () => {}, ...props }, ref) => {
    const [show, setShow] = useState(open)
    const overlayRef = useRef(null)

    useEffect(() => {
      setShow(open)
    }, [open])

    const handleClose = () => {
      setShow(false)
      onClose()
    }

    const handleClickOutsideModal = (e) => {
      if (e.target !== overlayRef.current) return
      handleClose()
    }

    useEffect(() => {
      if (show) {
        document.body.classList.add('interstitial-activated')
      } else {
        document.body.classList.remove('interstitial-activated')
      }
      return () => document.body.classList.remove('interstitial-activated')
    }, [show])

    return (
      <Portal>
        <div ref={ref} className={clsx('add-new-path-modal-overlay dome-full-width dome-full-height', show && 'show')}>
          <div
            ref={overlayRef}
            onClick={handleClickOutsideModal}
            className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
          >
            <div className="add-new-path-modal-container">
              <ConfirmRemoveSection
                {...props}
                onSubmit={(value) => {
                  handleClose()
                  onSubmit(value)
                }}
                onCancel={handleClose}
              />
            </div>
          </div>
        </div>
      </Portal>
    )
  }
)

ConfirmRemoveSectionModal.displayName = 'ConfirmRemoveSectionModal'

export default ConfirmRemoveSectionModal
